import { CheckCircleIcon, MinusCircleIcon, PhoneIcon } from '@heroicons/react/solid'
import { useLocation } from "react-router-dom";
import React,{ useEffect, useState } from "react";
import Accordion from './Accordion';


export default function Servicios(){

    const [activeIndex, setActiveIndex] = useState(1);
    const location = useLocation();

    useEffect(() => {
        if(location.pathname === "/Servicios" )
        {
            let srv = document.getElementById('divServicios')
            srv.classList.remove('mt-[180px]')
            srv.classList.add('mt-[40px]')
        }
    });
    
    return(
        <div id="divServicios" className="container mx-auto mt-[180px] lg:mt-11 mb-5">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 ">
                <div className="grid grid-cols-2 gap-6">
                    <div className="relative flex gap-1 overflow-hidden scroll-smooth  touch-pan-x z-0">
                        <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0">
                            <div className="md:mx-auto relative imgPaisaje1 flex justify-center"></div>
                        </div>
                        <a
                            href='/Paquetes'
                            className="overflow-auto h-full w-full aspect-square block absolute top-0 lg:top-1/2 left-0 transition-opacity duration-300 opacity-0 hover:opacity-100 bg-blue-800/75 z-10"
                        >
                            <h1 className="text-white py-6 px-3 mx-auto font-medium text-xl inline-block">
                                Ver paquetes y promociones
                            </h1>
                        </a>
                    </div>
                    <div className="relative flex gap-1 overflow-hidden scroll-smooth  touch-pan-x z-0">
                        <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0">
                            <div className="md:mx-auto relative imgPaisaje2 flex justify-center"></div>
                        </div>
                        <a
                            href='/Paquetes'
                            className="overflow-auto h-full w-full aspect-square block absolute top-0 lg:top-1/2 left-0 transition-opacity duration-300 opacity-0 hover:opacity-100 bg-blue-800/75 z-10"
                        >
                            <h1 className="text-white py-6 px-3 mx-auto font-medium text-xl inline-block">
                                Ver paquetes y promociones
                            </h1>
                        </a>
                    </div>
                    <div className="relative flex gap-1 overflow-hidden scroll-smooth snap-x snap-mandatory touch-pan-x z-0">
                        <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0">
                            <div className="md:mx-auto relative imgPaisaje3 flex justify-center"></div>
                        </div>
                        <a
                            href='/Paquetes'
                            className="overflow-auto h-full w-full aspect-square block absolute top-0 lg:top-1/2 left-0 transition-opacity duration-300 opacity-0 hover:opacity-100 bg-blue-800/75 z-10"
                        >
                            <h1 className="text-white py-6 px-3 mx-auto font-medium text-xl inline-block">
                                Ver paquetes y promociones
                            </h1>
                        </a>
                    </div>
                    <div className="relative flex gap-1 overflow-hidden scroll-smooth snap-x snap-mandatory touch-pan-x z-0">
                        <div className="h-full w-full aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0">
                            <div className="md:mx-auto relative imgPaisaje4 flex justify-center"></div>
                        </div>
                        <a
                            href='/Paquetes'
                            className="overflow-auto h-full w-full aspect-square block absolute top-0 lg:top-1/2 left-0 transition-opacity duration-300 opacity-0 hover:opacity-100 bg-blue-800/75 z-10"
                        >
                            <h1 className="text-white py-6 px-3 mx-auto font-medium text-xl inline-block">
                                Ver paquetes y promociones
                            </h1>
                        </a>
                    </div>
                </div>
                <div className="p-5">
                    <div className="text-center">
                        <h1 className="font-bold text-green-400 text-3xl">Servicios</h1>
                    </div>
                    <div className="flex flex-col space-y-7 lg:px-4 text-black mt-10">
                        <Accordion 
                            title={"Destinos Nacionales"}             
                            index={1}            
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                        >
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Cancún</p>
                                    <p className='pl-2'>- Riviera Maya</p>
                                    <p className='pl-2'>- Costa Mujeres</p>
                                    <p className='pl-2'>- Cozumel</p>
                                    <p className='pl-2'>- Holbox</p>
                                    <p className='pl-2'>- Bacalar</p>
                                    <p className='pl-2'>- Playa del Carmen</p>
                                    <p className='pl-2'>- Isla Mujeres</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Huatulco</p>
                                    <p className='pl-2'>- Puerto Escondido</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Puerto Vallarta</p>
                                    <p className='pl-2'>- Nuevo Vallarta</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Riviera Nayarit</p>
                                    <p className='pl-2'>- Guayabitos</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Los cabos</p>
                                    <p className='pl-2'>- San José del Cabo</p>
                                    <p className='pl-2'>- La paz</p>
                                    <p className='pl-2'>- Cabo San Lucas</p>
                                    <p className='pl-2'>- Baja California</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Acapulco</p>
                                    <p className='pl-2'>- Ixtapa Zihuatanejo</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Mazatlán</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Manzanillo</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Veracruz</p>
                                    <p className='pl-2'>- Tecolutla</p>
                                    <p className='pl-2'>- El Tajin</p>
                                    <p className='pl-2'>- Costa Esmeralda</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Mérida</p>
                                    <p className='pl-2'>- Puerto Progreso</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Campeche</p>
                                </div>
                            </div>
                        </Accordion>
                        <Accordion 
                            title={"Destinos de Ciudad"}             
                            index={2}            
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                        >
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Toluca</p>
                                    <p className='pl-2'>- Valle de Bravo</p>
                                    <p className='pl-2'>- Nevado de Toluca</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Taxco</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Hidalgo</p>
                                    <p className='pl-2'>- Grutas de Tolantongo</p>
                                    <p className='pl-2'>- Prismas Basálticos</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Querétaro</p>
                                    <p className='pl-2'>- Peña de Bernal</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Huasteca Potosina</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Guanajuato</p>
                                    <p className='pl-2'>- León</p>
                                    <p className='pl-2'>- San Miguel de Allende</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Chiapas</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Chihuahua</p>
                                    <p className='pl-2'>- Barranca del Cobre</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Ciudad de México(CDMX)</p>
                                    <p className='pl-2'>- Centro Histórico de la ciudad de México</p>
                                    <p className='pl-2'>- Teotihuacan</p>
                                    <p className='pl-2'>- Xochimilco</p>
                                    <p className='pl-2'>- Coyoacán (Museo Frida Kahlo)</p>
                                    <p className='pl-2'>- Six Flags México</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Puebla</p>
                                    <p className='pl-2'>- Africam Safari</p>
                                    <p className='pl-2'>- Cholula de Rivadavia</p>
                                </div>
                            </div>
                        </Accordion>
                        <Accordion 
                            title={"Tours de playa"}             
                            index={3}            
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                        >
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Cancún</p>
                                    <p className='pl-2'>- Xcaret</p>
                                    <p className='pl-2'>- Xel-Há</p>
                                    <p className='pl-2'>- Isla Mujeres</p>
                                    <p className='pl-2'>- Tulum</p>
                                    <p className='pl-2'>- Chichén Itzá</p>
                                    <p className='pl-2'>- Valladolid</p>
                                    <p className='pl-2'>- Cenote</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Los Cabos</p>
                                    <p className='pl-2'>- Tour en camellos</p>
                                    <p className='pl-2'>- Tour en caballos</p>
                                    <p className='pl-2'>- Tour en cuatrimotos</p>
                                    <p className='pl-2'>- Tour al arco</p>
                                    <p className='pl-2'>- Nadar con Delfines</p>
                                    <p className='pl-2'>- Balandra</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Huatulco</p>
                                    <p className='pl-2'>- Mazunte</p>
                                    <p className='pl-2'>- 7 Bahías</p>
                                    <p className='pl-2'>- Puerto Ángel</p>
                                    <p className='pl-2'>- Zipolite</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Riviera Nayarit</p>
                                    <p className='pl-2'>- Islas Marietas</p>
                                    <p className='pl-2'>- Paseo en Barco Pirata</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Acapulco</p>
                                    <p className='pl-2'>- Isla Roqueta</p>
                                    <p className='pl-2'>- La Quebrada</p>
                                    <p className='pl-2'>- Pie de la Cuesta</p>
                                    <p className='pl-2'>- Playa Bonfil</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Veracruz</p>
                                    <p className='pl-2'>- Los Rapidos</p>
                                </div>
                            </div>
                        </Accordion>
                        <Accordion 
                            title={"Circuitos Internacionales"}             
                            index={4}            
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                        >
                            <div className="flex flex-row mt-3">
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl font-medium'>Europa</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Francia</p>
                                    <p className='pl-2'>- París</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Italia</p>
                                    <p className='pl-2'>- Roma</p>
                                    <p className='pl-2'>- Venecia</p>
                                    <p className='pl-2'>- Vaticano</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Inglaterra</p>
                                    <p className='pl-2'>- Londres</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>España</p>
                                    <p className='pl-2'>- Madrid</p>
                                    <p className='pl-2'>- Barcelona</p>
                                    <p className='pl-2'>- Sevilla</p>
                                    <p className='pl-2'>- Toledo</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Alemania</p>
                                    <p className='pl-2'>- Berlín</p>
                                    <p className='pl-2'>- Colonia</p>
                                    <p className='pl-2'>- Fráncfort</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl font-medium'>Medio Oriente</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Egipto</p>
                                    <p className='pl-2'>-Israel (Tierra Santa)</p>
                                    <p className='pl-2'>- Dubái</p>
                                    <p className='pl-2'>- Turquía</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl font-medium'>Asia</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>China</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Japón</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Tailandia</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>India</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Corea</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl font-medium'>África</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Sudáfrica</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl font-medium'>Oceanía</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Australia</p>
                                    <p className='pl-2'>- Sídney</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Nueva Zelanda</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl font-medium'>Norteamérica</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Estados Unidos</p>
                                    <p className='pl-2'>- Nueva York</p>
                                    <p className='pl-2'>- Las Vegas</p>
                                    <p className='pl-2'>- California</p>
                                    <p className='pl-2'>- Orlando</p>
                                    <p className='pl-2'>- Miami</p>
                                    <p className='pl-2'>- Alaska</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Canadá</p>
                                    <p className='pl-2'>- Quebec</p>
                                    <p className='pl-2'>- Vancouver</p>
                                    <p className='pl-2'>- Niágara</p>
                                    <p className='pl-2'>- Montreal</p>
                                    <p className='pl-2'>- Ottawa</p>
                                    <p className='pl-2'>- Victoria</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl font-medium'>Centroamérica</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Panamá</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Cuba</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Costa Rica</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>República Dominicana</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Guatemala</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl font-medium'>Sudamérica</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Brasil</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Argentina</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Colombia</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Ecuador</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Chile</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Perú</p>
                                </div>
                            </div>
                        </Accordion>
                        <Accordion 
                            title={"Traslados"}             
                            index={5}            
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                        >
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Traslado Compartido o Privado</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Traslado Aeropuerto – Hotel</p>
                                    <p className='pl-2'>- Individual y grupal</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Traslado de Ciudad</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Traslado en los Tours</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Traslado Ejecutivo</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Traslado de Negocios</p>
                                </div>
                            </div>
                        </Accordion>
                        <Accordion 
                            title={"Renta de Vehiculos"}             
                            index={6}            
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                        >
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Renta de Autos</p>
                                    <p lassName='pl-2'>- En destinos turísticos por día o por semana</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Renta de Camionetas</p>
                                    <p lassName='pl-2'>- Para salidas de fin de semana dentro de la república</p>
                                    <p lassName='pl-2'>- Turismo o negocios</p>
                                </div>
                            </div>
                            <div className="flex flex-row mt-3">
                                <CheckCircleIcon className="h-8 w-8 text-purple-900 basis-1/6"/>
                                <div className="flex flex-col pl-5">
                                    <p className='text-2xl'>Renta de Autobuses</p>
                                    <p lassName='pl-2'>- Para Excursiones</p>
                                    <p lassName='pl-2'>- Salidas Escolares</p>
                                    <p lassName='pl-2'>- Salidas de Vacacionales</p>
                                </div>
                            </div>
                        </Accordion>
                        <div className='flex justify-center mt-1'>
                            <a href='https://wa.me/+5215527364548?&text=Hola.!!%20Quisiera%20reservar%20un%20viaje' target="_blank" rel="noreferrer">
                                <div className='bg-regal-blue shadow-md text-white rounded-md font-semibold flex items-center py-8 text-xl h-10 xl:px-3 xl:items-center rounded-full w-80 h-auto border border-green justify-center'>
                                    Aparta con un 35%
                                    <PhoneIcon className='h-10 w-10 px-2 text-green-400 basis-1/6'/>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}